module.exports = __webpack_public_path__ + "themes/custom/iidb/dist/img/logo-asp-pl.02dcd1ce.svg";